export const [NORMAL, READY, RECORDING, STOPPED, UPLOADING, SAVED] = ['NORMAL', 'READY', 'RECORDING', 'STOPPED', 'UPLOADING', 'SAVED'];
export const [PLAYING, PAUSED, INITIAL, IDLE] = ['PLAYING', 'PAUSED', 'INITIAL', 'IDLE'];
export const PERMISSION_DENIED = 'permission_denied';
